module.exports = __webpack_public_path__ + "static/media/not-allowed.4bf3745d.svg";